export type GetDipByRegionListRequest = {};
